'use client'

import PolygonLabel from '@component/mapbox/layer/polygonLabel'
import useFetch from '@hooks/useFetch'
import { size } from 'lodash-es'

export default function RectLabel({
  data
}) {

  const { data: boundrayDistance } = useFetch(
    data.propertyId
      ? `property-boundray-distance/${data.propertyId}`
      : null
  )

  return size(boundrayDistance) > 0 && (
    <PolygonLabel data={boundrayDistance}></PolygonLabel>
  )
}